import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite/dist/flowbite.turbo.js";
import "./channels"
import "./lib/turbo_stream_actions/fetch"
import "./pwa"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import { dom } from "@fortawesome/fontawesome-svg-core";
import { library } from '@fortawesome/fontawesome-svg-core'
import { all } from '@awesome.me/kit-91ae18f832/icons'
library.add(...all)
dom.watch();

import ahoy from "ahoy.js"

// For icon replacement in Turbo Frames
document.addEventListener("turbo:frame-load", () => {
  dom.i2svg()
})

// For full page views (Ahoy)
document.addEventListener("turbo:load", function() {
    ahoy.trackView();
});